<div class="card  h-100 mb-4 rounded-0 context-menu">

    <div class="px-4 d-flex mt-3">
        <div>
            <img src="../../../../assets/common/images/Activities/dashboardCalendar.svg" class="h-20px w-20px rounded" />

        </div>
        <div class="pl-3">
            <div class="font-weight-bolder h5">
                {{'MyTaskList' | localize}}
            </div>
        </div>
        <div *ngIf="isLoaded && isTaskListRecordsEmpty" class="ml-auto cursor-pointer">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <!--Shimmer Section Code-->
    <div *ngIf="!isLoaded && !isTaskListRecordsEmpty" class="row px-4 mb-2 mt-2">
        <div class="col-md-12">
            <app-dashboard-table-skeleton
                [columnCount]="7"
                [columnWidths]="['18%', '18%']"
                [rows]="4"
                [secondColMultiLine]="true">
            </app-dashboard-table-skeleton>
        </div>
    </div>

    <div>
        <div *ngIf="isLoaded && !isTaskListRecordsEmpty" class="card h-350px">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-20">
                    <img src="../../../../assets/common/images/new-dashboard/task-list-empty-ui.svg" class="h-200px w-275px ml-8" />
                    <h6 class="text-muted text-center mt-4 ml-22">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>
        </div>

    </div>

    <!--old task list p-table-->
    <!--updated task list p-table-->

    <div *ngIf="isLoaded && isTaskListRecordsEmpty" class="row px-4 mb-2 mt-2">
        <div class="col-md-12">
            <div id="TaskList-data-table">
                <p-table [rows]="4"
                         [value]="taskDetailsNew"
                         [paginator]="false">
                    <ng-template pTemplate="header">
                            <tr [ngClass]="'textcolor'">
                                <th style="width: 18%;">{{'ProjectName' |localize}}</th>
                                <th style="width: 18%;">{{'Task'|localize}}</th>
                                <th>{{'Priority'|localize}}</th>
                                <th>{{'Severity'|localize}}</th>
                                <th>{{'Estimation'|localize}}</th>
                                <th>{{'TimeSpend'|localize}}</th>
                                <th class="">{{'Status'|localize}}</th>
                            </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-UserTaskListDashBoard>
                        <tr [ngClass]="'textcolor bg-hover-gray-100'">

                            <td>
                                <div class="d-flex flex-lg-fill">
                                    <div class="mr-4 project-image-container">
                                        <img *ngIf="UserTaskListDashBoard.projectImage" src="{{ UserTaskListDashBoard.projectImage }}" class="h-30px w-30px border border-light rounded" alt="" id="profimgsize" />
                                        <img *ngIf="!UserTaskListDashBoard.projectImage"
                                             src="{{ 'assets/common/images/new-dashboard/default-project-bag.svg' }}"
                                             class="h-30px w-30px border border-light rounded"
                                             alt="" id="profimgsize"/>
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                        <span class="d-flex">
                                            <span class="font-size-base font-weight-bolder text-dark-65" pTooltip="{{ UserTaskListDashBoard.projectName }}" [tooltipDisabled]="UserTaskListDashBoard.projectName | tooltipDisabled:17" tooltipPosition="bottom">{{ UserTaskListDashBoard.projectName | slice:0:17 }}{{ UserTaskListDashBoard.projectName.length > 17 ? '...' : '' }}</span>
                                        </span>
                                    </div>
                                </div>

                            </td>

                            <td>
                                <div class="d-flex flex-column">
                                    <span class="d-flex">
                                        <span class="font-size-base font-weight-bolder" pTooltip="{{ UserTaskListDashBoard.taskName }}" [tooltipDisabled]="UserTaskListDashBoard.taskName | tooltipDisabled:15" tooltipPosition="bottom">{{ UserTaskListDashBoard.taskName | slice:0:15 }}{{ UserTaskListDashBoard.taskName.length > 15 ? '...' : '' }}</span>

                                    </span>
                                    <div class="d-flex flex-wrap align-items-center mt-1">
                                        <i *ngIf="UserTaskListDashBoard.billableType"></i>
                                        <span *ngIf="UserTaskListDashBoard.billableType && UserTaskListDashBoard.billableType == 1" class="text-dark-50 font-size-xs mr-2"><img src="assets/common/images/billable.png" alt="" width="14px"> | </span>
                                        <span *ngIf="UserTaskListDashBoard.billableType && UserTaskListDashBoard.billableType == 2" class="text-dark-50 font-size-xs mr-2"><img src="assets/common/images/nonbillable.png" alt="" width="14px"> | </span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 1" class="text-dark-50 font-size-xs mr-2">{{'Development' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 2" class="text-dark-50 font-size-xs mr-2">{{'Design' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 3" class="text-dark-50 font-size-xs mr-2">{{'Requirement' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 4" class="text-dark-50 font-size-xs mr-2">{{'Documentation' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 5" class="text-dark-50 font-size-xs mr-2">{{'Testing' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 6" class="text-dark-50 font-size-xs mr-2">{{'Miscellaneous' | localize}}</span>

                                        <span *ngIf="!UserTaskListDashBoard.taskActivityId" class="label label-rounded label-light-success w-50px h-15px">-</span>
                                    </div>
                                </div>

                            </td>

                            <td>
                                <div class="d-flex flex-wrap align-items-center">
                                    <span *ngIf="UserTaskListDashBoard.taskPriorityId == 1" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 high-priority"></i>
                                        {{ 'High' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskPriorityId == 2" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 moderate-priority"></i>
                                        {{ 'Moderate' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskPriorityId == 3" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 low-priority"></i>
                                        {{ 'Low' | localize }}
                                    </span>
                                    <span *ngIf="!UserTaskListDashBoard.taskPriorityId" class="text-dark-50 font-size-sm mr-2">
                                        -
                                    </span>
                                </div>

                            </td>

                            <td>

                                <div class="d-flex flex-wrap align-items-center">
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 1" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 critical-severity"></i>
                                        {{ 'Critical' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 2" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 high-severity"></i>
                                        {{ 'High' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 3" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 medium-severity"></i>
                                        {{ 'Medium' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 4" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 low-severity"></i>
                                        {{ 'Low' | localize }}
                                    </span>
                                    <span *ngIf="!UserTaskListDashBoard.taskSeverityId" class="text-dark-50 font-size-sm mr-2">
                                        -
                                    </span>
                                </div>

                            </td>

                            <td>
                                <span>
                                    <span class="text-dark-50 font-size-sm">{{ getOriginalEstimateHour(UserTaskListDashBoard.originalEstimatedHours) }}</span>
                                </span>
                            </td>

                            <td>
                                <span>
                                    <span class="text-dark-50 font-size-sm">{{getHrsAndMinutes(UserTaskListDashBoard.totalCompletedHours | hourstoTimeSpan)}}</span>
                                </span>
                            </td>

                            <td>
                                <span>
                                    <span class="label label-outline-secondary  rounded-pill h-28px w-80px label-inline border  bg-white justify-content-start  text-center" [ngClass]="{'status-width':UserTaskListDashBoard.taskStatusId ==  4, 'w-105px':UserTaskListDashBoard.taskStatusId ==  2}">
                                        <span class=" span-allign-center text-center mx-auto">
                                            <span class="label label-dot" [ngClass]="{'label-primary':UserTaskListDashBoard.taskStatusId == 1,'label-warning':UserTaskListDashBoard.taskStatusId == 2,'label-danger':UserTaskListDashBoard.taskStatusId == 3,'label-success':UserTaskListDashBoard.taskStatusId == 4}"></span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId  == 1" class="ml-2">{{'New' | localize}}</span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId  == 2" class="ml-2">{{'InProgress1' | localize}}</span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId == 3" class="ml-2">{{'Overdue' | localize}}</span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId ==  4" class="ml-2">{{'Complete'| localize}}</span>
                                        </span>

                                    </span>
                                </span>

                            </td>
                        </tr>
                    </ng-template>
                </p-table>

            </div>
        </div>

    </div>

</div>

